// 고객지원 문의 시트
//
// mailto를 바로 쏘지 않고 시트를 한 번 거치는 이유:
//   안드로이드는 처리할 메일 앱이 없으면 mailto Intent에서 ActivityNotFoundException이 나
//   네이티브 레이어에서 앱이 죽는다. JS try/catch로 못 막는다.
//   시트에 "주소 복사"를 나란히 두면 메일 앱이 없는 사용자도 문의 경로를 잃지 않는다.
//
// 본문 prefill은 supportInquiry.ts — 유저가 메일 앱에서 전문을 보고 보낸다.

import { useState } from "react";
import { BottomSheet } from "../../components/shared/BottomSheet";
import { openMail, copyText, SUPPORT_EMAIL } from "../../lib/externalLink";
import { buildInquiryBody, collectInquiryContext } from "../../lib/supportInquiry";
import { showError, showSuccess } from "../../lib/toast";
import { useAuth } from "../../lib/useAuth";
import { getAppVersion } from "../../lib/appMeta";

export function SupportSheet({ open, onClose }: { open: boolean; onClose: () => void }) {
  const { user } = useAuth();
  const [copied, setCopied] = useState(false);

  const handleMail = async () => {
    const ctx = collectInquiryContext(user, await getAppVersion(), __BUILD_TIME__);
    openMail("[솟다] 문의", buildInquiryBody(ctx));
    onClose();
  };

  const handleCopy = async () => {
    const ok = await copyText(SUPPORT_EMAIL);
    setCopied(ok);
    if (ok) showSuccess("문의 주소를 복사했어요");
    else showError("복사에 실패했어요. 주소를 직접 입력해주세요");
  };

  return (
    <BottomSheet open={open} onClose={onClose} title="문의하기">
      <div style={{ padding: "4px 2px 8px", fontSize: 13, lineHeight: 1.7, color: "var(--cs-ink-2)" }}>
        궁금하거나 불편한 점을 메일로 보내주시면 확인 후 답변드릴게요.
        <div style={{ marginTop: 12, padding: "12px 14px", background: "var(--cs-surface-2)", borderRadius: "var(--cs-r-md)" }}>
          <div style={{ fontSize: 11, color: "var(--cs-mute)", marginBottom: 4 }}>문의 주소</div>
          <div style={{ fontSize: 13.5, fontWeight: 600, color: "var(--cs-ink)", fontFamily: "var(--cs-font-mono)" }}>
            {SUPPORT_EMAIL}
          </div>
        </div>
        <div style={{ marginTop: 10, fontSize: 11.5, color: "var(--cs-mute)", lineHeight: 1.6 }}>
          빠른 확인을 위해 계정·앱 버전·기기 정보가 메일 본문에 자동으로 담겨요.
          보내기 전에 직접 확인하실 수 있어요.
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: 8, paddingBottom: 4 }}>
        <button
          type="button"
          onClick={handleMail}
          style={{
            width: "100%", padding: "13px 0", border: "none", cursor: "pointer",
            background: "var(--cs-accent)", color: "var(--cs-accent-ink)",
            borderRadius: "var(--cs-r-pill)", fontSize: 14, fontWeight: 700, fontFamily: "inherit",
          }}
        >
          메일 앱으로 문의하기
        </button>
        <button
          type="button"
          onClick={handleCopy}
          style={{
            width: "100%", padding: "12px 0", border: "none", cursor: "pointer",
            background: "var(--cs-surface-2)", color: "var(--cs-ink-2)",
            borderRadius: "var(--cs-r-pill)", fontSize: 13, fontWeight: 600, fontFamily: "inherit",
          }}
        >
          {copied ? "복사됨 ✓" : "메일 주소 복사"}
        </button>
      </div>
    </BottomSheet>
  );
}
